import { oz } from '@weft/utils';
import type { Stripe } from 'stripe';

export const StripeEventRequestSchema = oz.custom<Stripe.Event>();

export type StripeEventRequestPayload = oz.infer<typeof StripeEventRequestSchema>;